/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const CustomerInvoiceService = {
  async saveCustomerInvoiceDueDate(payload, invoiceId) {
    const url = `api/Save_CustomerInvoiceDueDate`;

    if (invoiceId) {
      return await ApiService.put(url, invoiceId, payload, "Integer");
    } else {
      return await ApiService.post(url, payload);
    }
  },

  async getInvoiceByCustomerCode(Code, select) {
    var requestScreenData = {
      url: "api/InvoiceList",
      filter: `CustomerCode eq '${Code}'`,
      select: select ? select : undefined
    };
    return await ApiService.oDataGet(requestScreenData);
  },
  async getInvoiceByInvoiceCode(Code, select) {
    var requestScreenData = {
      url: "api/InvoiceList",
      filter: `Invoice eq ${Code}`,
      select: select ? select : undefined
    };
    return await ApiService.oDataGet(requestScreenData);
  },

  async getInvoiceByCode(Code) {
    var requestScreenData = {
      url: "api/Invoice",
      filter: `Code eq ${Code}`,
    };
    return await ApiService.oDataGet(requestScreenData);
  },
};

export { CustomerInvoiceService };
